module.exports = __webpack_public_path__ + "img/test_month_ai.ce3983eb.jpg";